import React from 'react'
import PropTypes from 'prop-types'

class DoctypesSelect extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            isListVisible: false,
        }

        if (!this.props.onChangeCoverLetters) {
            this.props.onChangeCoverLetters = () => {}
        }
        if (!this.props.onChange) {
            this.props.onChange = () => {}
        }

        this.handleSelectedDoctypeClick = this.handleSelectedDoctypeClick.bind(this)
        this.handleDoctypeInListClick = this.handleDoctypeInListClick.bind(this)
        this.handleChangeCoverLetters = this.handleChangeCoverLetters.bind(this)
    }

    handleSelectedDoctypeClick() {
        if (!this.state.isListVisible) {
            document.addEventListener('click', this.handleSelectedDoctypeClick, false)
        } else {
            document.removeEventListener('click', this.handleSelectedDoctypeClick, false)
        }

        this.setState(prevState => ({
            isListVisible: !prevState.isListVisible
        }))
    }

    handleDoctypeInListClick(doctypeId) {
        if (this.props.selectedDoctypeId !== doctypeId) {
            this.props.onChange(doctypeId)
        }
    }

    handleChangeCoverLetters(event) {
        this.props.onChangeCoverLetters(event.target.value)
    }

    render() {
        const doctypes = this.props.doctypes
        const isCoverLetter = this.props.isCoverLetter
        const coverLetters = this.props.coverLetters
        const doctypesPrices = this.props.doctypesPrices
        const selectedDoctype = this.props.selectedDoctype
        const currencySymbol = this.props.currencySymbol
        const selectedCoverLettersCount = this.props.selectedCoverLettersCount

        const isListVisible = this.state.isListVisible

        return (
            <div>
                <div className="order-form__item">
                    <div className="order-form__label">Product</div>
                    <div className="order-form__value">
                        <div className="order-form__select-wrp custom-sel">
                            <div className="select-box product-data order-details__select clearfix">
                                <span className="select-box__selected" onClick={this.handleSelectedDoctypeClick} >
                                    <span className="doctype-name" data-value={selectedDoctype.id}>{selectedDoctype.name}</span>
                                    <span className="doctype-price">{currencySymbol}{doctypesPrices[selectedDoctype.id]}</span>
                                </span>
                                <div id="doctypes-list" className={'select-options ' + (isListVisible ? 'open' : '')}>
                                    {doctypes.map(doctype => (
                                        <span key={doctype.id} className={'select-option option-' + doctype.id} onClick={() => this.handleDoctypeInListClick(parseInt(doctype.id))}>
                                            <span className="doctype-name" data-value={doctype.id}>{doctype.name}</span>
                                            <span className="doctype-price">{currencySymbol}{doctypesPrices[doctype.id]}</span>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {isCoverLetter &&
                <div className="order-form__select-wrp cover-letters clearfix">
                    <label className="order-form__label" htmlFor="cover_letters">Number of cover letters:</label>
                    <div className="order-details__select order-form__value">
                        <select id="cover_letters" value={selectedCoverLettersCount} onChange={this.handleChangeCoverLetters}>
                            {Object.keys(coverLetters).map(key => (
                                <option key={key} value={coverLetters[key]}>{coverLetters[key]}</option>
                            ))}
                        </select>
                    </div>
                </div>
                }
            </div>
        )
    }
}

DoctypesSelect.propTypes = {
    doctypes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
    coverLetters: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedDoctype: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    isCoverLetter: PropTypes.bool.isRequired,
    doctypesPrices: PropTypes.objectOf(PropTypes.number).isRequired,
    currencySymbol: PropTypes.string.isRequired,
    selectedCoverLettersCount: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    onChangeCoverLetters: PropTypes.func,
}

export default DoctypesSelect;